module Meevo.Plugins.AlertsManager {

    class MeevoReviewSettingsTabComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
        ];

        public params: IParams;
        public currentStep: number;
        public alertIsSelected: boolean;
        public serviceIsBooked: string = 'EmployeeServiceMoverConfig';

        public get labelTriggeredBy(): string {
            const enumDto = this.alertsManagerService.triggeredByLabels.find((item) => item.id === this.params.alertSetting.systemAlertTriggeredType);
            if (!enumDto) {
                return '';
            }

            return enumDto.displayName;
        }

        public get triggeredByEmployeeAndUserList() {
            return [...this.params.triggeredByList, ...this.params.triggeredUsersByList];
        }

        public get receivedByEmployeeAndUserList() {
            return [...this.params.receivedByList, ...this.params.receivedUsersByList];
        }

        constructor(protected alertsManagerService: IAlertsManagerService) {
        }

        selectStep(tabIndex: number) {
            if (!this.alertIsSelected) return;

            this.currentStep = tabIndex;
        }

    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoReviewSettingsTabComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/tabs/review-settings-tab/review-settings-tab.component.html',
            controller: MeevoReviewSettingsTabComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                alertIsSelected: '<',
                currentStep: '=?'
            }
        });
}
